import Mass from '@FreeRider/Physics/Mass';
import Vehicle from '@FreeRider/Player/Vehicles/BaseVehicle';

class Spring
{
    private parent: Vehicle;
    public m1: Mass;
    public m2: Mass;
    public lrest: number;
    public leff: number;
    public damp_constant: number;
    public spring_constant: number;

    /**
     * Constructor
     * @param mass1
     * @param mass2
     * @param parent
     */
    constructor(mass1: Mass, mass2: Mass, parent)
    {
        this.m1 = mass1;
        this.m2 = mass2;
        this.parent = parent;
        this.lrest = 40;
        this.leff = 40;
        this.damp_constant = 0.5;
        this.spring_constant = 0.7;
    }

    /**
     * Swaps spring direction
     * @todo clean up cartesians
     */
    public swap()
    {
        const m1 = this.m1;
        const m2 = this.m2;

        let temp_x = m1.position.x;
        let temp_y = m1.position.y;

        m1.position.x = m2.position.x;
        m1.position.y = m2.position.y;

        m2.position.x = temp_x;
        m2.position.y = temp_y;

        temp_x = m1.old.x;
        temp_y = m1.old.y;

        m1.old.x = m2.old.x;
        m1.old.y = m2.old.y;

        m2.old.x = temp_x;
        m2.old.y = temp_y;

        temp_x = m1.vel.x;
        temp_y = m1.vel.y;

        m1.vel.x = m2.vel.x;
        m1.vel.y = m2.vel.y;

        m2.vel.x = temp_x;
        m2.vel.y = temp_y;

        var temp2 = m1.angle;
        m1.angle = m2.angle;
        m2.angle = temp2;
    };


    /**
     * Updates spring
     * @todo cleanup cartesians
     */
    public update()
    {
        let mm_x = 0;
        let mm_y = 0;

        const m1 = this.m1;
        const m2 = this.m2;

        const m1_pos = m1.position;
        const m2_pos = m2.position;

        const m1_vel = m1.vel;
        const m2_vel = m2.vel;

        mm_x = m2_pos.x - m1_pos.x;
        mm_y = m2_pos.y - m1_pos.y;

        const sep = Math.sqrt(Math.pow(mm_x, 2) + Math.pow(mm_y, 2));

        if (sep < 1)
        {
            return;
        }

        const factor_sep = 1 / sep;
        mm_x *= factor_sep;
        mm_y *= factor_sep;

        const mm_factor = (sep - this.leff) * this.spring_constant;

        let tens_x = mm_x * mm_factor;
        let tens_y = mm_y * mm_factor;

        const damp_x = m2_vel.x - m1_vel.x;
        const damp_y = m2_vel.y - m1_vel.y;

        const damp_dot = (damp_x * mm_x) + (damp_y * mm_y);
        const damp = damp_dot * this.damp_constant;

        const mm_factor_x = (mm_x * damp);
        const mm_factor_y = (mm_y * damp);

        tens_x += mm_factor_x;
        tens_y += mm_factor_y;

        m2_vel.x += -tens_x;
        m2_vel.y += -tens_y;

        m1_vel.x += tens_x;
        m1_vel.y += tens_y;
    };

    /**
     * Rotate
     * @param p
     */
    public rotate(p)
    {
        const m1 = this.m1;
        const m2 = this.m2;

        const mm_x = m2.position.x - m1.position.x;
        const mm_y = m2.position.y - m1.position.y;

        const n_x = -mm_y / this.leff;
        const n_y = mm_x / this.leff;

        m1.position.x += (n_x * p);
        m1.position.y += (n_y * p);

        m2.position.x += (n_x * -p);
        m2.position.y += (n_y * -p);
    };

    /**
     * Constract
     * @param p1
     * @param p2
     */
    public contract(p1, p2)
    {
        this.leff += (this.lrest - p1 - this.leff) / p2;
    };

}

export default Spring;